export interface IImageData {
    readonly id?: number
    name?: string
    readonly file?: string
}

export interface IImageSimple {
    readonly url?: string
    readonly alt?: string
}

export interface IImage extends IImageData {
    readonly file: string
    validate(): boolean
    update(data?: IImageData): void
}

export const IMAGE_NAME_MAX_LENGTH = 100;
